module.exports = __webpack_public_path__ + "img/logo.a540799f.png";